import React from 'react'
import { Flex, Spacer, Text, Link, useColorModeValue as colorValue } from '@chakra-ui/react'

const Footer = () => {
    return (
        <Flex p={4} bgColor={colorValue("blue.700","blue.900")} color="white" direction={{base:"column", lg:"row"}} align="center">
            <Text align="center">{process.env.REACT_APP_FULL_NAME}</Text>
            <Text ml={{md:"6px"}}>เวอร์ชัน {process.env.REACT_APP_VERSION}</Text>
            <Spacer />
            <Link isExternal>
                <Text>กองสวัสดิการ สำนักงานศาลยุติธรรม</Text>
            </Link>
        </Flex>
    )
}

export default Footer
